






















































































































import { Meta } from '@/store/meta'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Server } from '@/store/server'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class RoomDetail extends Vue {
  loading = false
  copied = false

  get isLoading() {
    return this.loading
  }

  get meta() {
    return getModule(Meta)
  }

  get server() {
    return getModule(Server)
  }

  get room() {
    return this.server.roomDetailData
  }

  get emoSetting() {
    return this.server.emoSettingData
  }

  get memberCount() {
    return this.room ? this.room.room_members.length : 0
  }

  get uuidParam(): string {
    return this.$route.params.uuid
  }

  // 法人アカウント向けエントリ (BOCCOチャンネル → サービス詳細 → 部屋詳細) の場合、
  // route query の `service` に BOCCOサービスの broadcasterUuid が入ってくる。
  // 個人アカウントのエントリ (/rooms 一覧) 経由の場合は undefined。
  get broadcasterUuid(): string | undefined {
    const s = this.$route.query.service
    if (typeof s === 'string' && s.length > 0) return s
    return undefined
  }

  // /rooms/:uuid から別 uuid へ直接遷移した場合はコンポーネントが再利用されて
  // mounted が呼ばれないため、$route を watch して都度ロードし直す。
  @Watch('$route', { immediate: true })
  async loadRoom() {
    this.loading = true
    try {
      // 部屋と emo 情報を並列取得。emo 未登録の部屋は getEmoSettings 内で 4xx を握って
      // emoSettingData=null になる (画面側はテンプレの分岐で「未登録」を表示する)。
      // 法人アカウント経由なら broadcasterUuid を渡して X-Channel-User ヘッダを付ける。
      await Promise.all([
        this.server.getRoomDetail({ uuid: this.uuidParam, broadcasterUuid: this.broadcasterUuid }),
        this.server.getEmoSettings({ uuid: this.uuidParam, broadcasterUuid: this.broadcasterUuid }),
      ])
    } catch (e) {
      // 401/429 は interceptor 側で処理済み。それ以外は前回の詳細が残ったままにならないよう
      // state をクリアし、「取得できませんでした」表示に倒す。
      this.server.updateRoomDetailData(null)
      this.server.updateEmoSettingData(null)
      return
    } finally {
      this.loading = false
    }
  }

  async copyUuid(uuid: string) {
    try {
      await navigator.clipboard.writeText(uuid)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 1500)
    } catch (e) {
      console.warn('clipboard copy failed', e)
    }
  }
}
